import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import "./Location.css";
import { DeleteOutlined, PlusOutlined, StopOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  BASE_URL,
  DELETELocation,
  FetchLocation,
  UPDATELocation,
} from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import LocationForm from "../../features/addComapnyLocation/page/locationForm";
import { useDispatch } from "react-redux";
import { setLoc } from "../../store/slices/locationSlice";
import ModalConfirm from "../../common/modalConfirm";
function Location() {
  const dispatch = useDispatch();

  const [locationData, setLocationData] = useState([]);
  const [locationDisabledData, setLocationDisabledData] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [modalDeleteLocVisible, setModalDeleteLocVisible] = useState(false);
  const [deleteLocData, setDeleteLocData] = useState(null);

  const deleteLoc = (params) => {
    setModalDeleteLocVisible(true);
    setDeleteLocData(params);
  };
  const handleOk = (params) => {
    handleDelete(params);
    setModalDeleteLocVisible(false);
  };
  const handleCancel = () => {
    setModalDeleteLocVisible(false);
  };
  const [modalDisableLocVisible, setModalDisableLocVisible] = useState(false);
  const [disableLocData, setDisableLocData] = useState(null);

  const disableLoc = (params) => {
    setModalDisableLocVisible(true);
    setDisableLocData(params);
  };
  const handleDisableOk = (params) => {
    handleDelete(params);
    setModalDisableLocVisible(false);
  };
  const handleDisableCancel = () => {
    setModalDisableLocVisible(false);
  };
  const [activeLocationData, setActiveLocationData] = useState(null);
  const [modalActiveLocationVisible, setModalActiveLocationVisible] =
    useState(false);

  const activeBtnLocation = (params) => {
    setModalActiveLocationVisible(true);
    setActiveLocationData(params);
  };
  const handleActiveOk = (params) => {
    activeLocation(params);
    setModalActiveLocationVisible(false);
  };
  const handleActiveCancel = () => {
    setModalActiveLocationVisible(false);
  };
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const activeLocation = (data) => {
    const updatedState = { ...data };
    delete updatedState.boOwnerId;
    delete updatedState.isActive;
    delete updatedState.createdAt;
    delete updatedState.updatedAt;
    updatedState.isActive = true;
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${UPDATELocation}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(updatedState),
      });

      if (response.ok) {
        const data = await response.json();
        getLocationsList();
      } else {
        const data = await response.json();

        console.log("Location update failed:", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };

    fetchData();
  };
  const gridOptions = {
    getRowClass: (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return "RowColor";
      }
    },
  };
  const showForm = (item) => {
    setFormVisible(true);
  };
  const hideForm = () => {
    setFormVisible(false);
    setEditItem(null);
    getLocationsList();
  };
  const handleDelete = async (locationIndex) => {
    const locationId = locationIndex?.id;
    const token = localStorage.getItem("authToken");
    let bodyObj={}
    if(locationIndex?.isDeleted){
      bodyObj = {
        locationId: locationId,
          isDeleted:true
      }
    }
    else{
      bodyObj = {
        locationId: locationId,
      }
    }
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${DELETELocation}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(bodyObj),
      });

      if (response.ok) {
        const data = await response.json();
        getLocationsList();
      } else {
        const data = await response.json();
        console.log("departmenterr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };
  const handleEdit = (locationIndex) => {
    const location = locationData[locationIndex];
    setEditItem(null);
    setEditItem(location);
    showForm();
  };
  const handleDisabledEdit = (locationIndex) => {
    const location = locationDisabledData[locationIndex];
    setEditItem(null);
    setEditItem(location);
    showForm();
  };
  useEffect(() => {
    getLocationsList();
  }, []);
  const getLocationsList = async () => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${FetchLocation}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({isDeleted:false}),
      });

      if (response.ok) {
        const data = await response.json();
        const activeLocation = data.data.filter((item) => item.isActive);
        const disabledLocation = data.data.filter(
          (item) => item.isActive == false
        );
        setLocationData(activeLocation);
        setLocationDisabledData(disabledLocation);
        const newArray = activeLocation.map((item) => ({
          value: item.locationName1,
          key: item.locationId,
        }));
        sessionStorage.setItem("location", JSON.stringify(newArray));
        dispatch(setLoc(newArray));
      } else {
        const data = await response.json();
        console.log("locationerr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };
  const columns = [
    {
      headerName: "Location Name",
      field: "locationname",
    },
    {
      headerName: "Name",
      field: "name",
    },
    {
      headerName: "Description",
      field: "description",
    },
    {
      headerName: "Coordinates",
      field: "coordinates",
      cellRenderer: (params) => {
        return (
          <>
            <div>
              <div>{`${params.data.coordinates.latitude}`}</div>
              <div>{` ${params.data.coordinates.longitude}`}</div>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Google Maps Positions",
      field: "googlemap",
      flex: 1,
      cellRenderer: (params) => {
        return (
          <>
            <div>
              <a
                href={`${params.data.googlemap}`}
                target="_blank"
                className="text-[#4B8AEB]"
              >{`${params.data.googlemap}`}</a>
            </div>
          </>
        );
      },
    },

    {
      headerName: "Actions",
      field: "action",
      cellRenderer: (params) => {
        return (
          <>
            <div className="flex">
              <span className="shi-pen">
                <BsPencil onClick={() => handleEdit(params.data.key)} />
              </span>
              <span className="shi-not ml-2">
                <StopOutlined onClick={() => disableLoc({id :params.data?.item?.locationId, isDeleted:false})} />
              </span>
              <span className="shi-not ml-2">
                <DeleteOutlined onClick={() => deleteLoc({id :params.data?.item?.locationId, isDeleted:true})} />
              </span>
            </div>
          </>
        );
      },
    },
  ];
  const disabledcolumns = [
    {
      headerName: "Location Name",
      field: "locationname",
    },
    {
      headerName: "Name",
      field: "name",
    },
    {
      headerName: "Description",
      field: "description",
    },
    {
      headerName: "Coordinates",
      field: "coordinates",
      cellRenderer: (params) => {
        return (
          <>
            <div>
              <div>{`${params.data.coordinates.latitude}`}</div>
              <div>{` ${params.data.coordinates.longitude}`}</div>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Google Maps Positions",
      flex: 1,
      field: "googlemap",
      cellRenderer: (params) => {
        return (
          <>
            <div>
              <a
                href={`${params.data.googlemap}`}
                target="_blank"
                className="text-[#4B8AEB]"
              >{`${params.data.googlemap}`}</a>
            </div>
          </>
        );
      },
    },

    {
      headerName: "Actions",
      field: "action",
      cellRenderer: (params) => {
        console.log('paramsid',params)
        return (
          <>
            <div className="flex">
              {/* <span className='shi-pen'>
                             <BsPencil onClick={() => handleDisabledEdit(params.data.key)}/>
                          </span> */}
              <span className="shi-pen ml-2">
                <PlusOutlined
                  onClick={() => activeBtnLocation(params?.data?.item)}
                />
              </span>
              <span className="shi-not ml-2">
                <DeleteOutlined onClick={() => deleteLoc({id :params.data?.item?.locationId, isDeleted:true})} />
              </span>
            </div>
          </>
        );
      },
    },
  ];

  const data = locationData.map((item, index) => ({
    key: index,
    item: item,
    locationname: capitalizeFirstLetter(item.locationName1),
    name: capitalizeFirstLetter(item.locationName2),
    description: capitalizeFirstLetter(item.description),
    coordinates: {
      latitude: item?.googleMapPosition?.latitude,
      longitude: item?.googleMapPosition?.longitude,
    },
    googlemap: `https://www.google.com/maps?q=${item?.googleMapPosition?.latitude},${item?.googleMapPosition?.longitude}`,
    
  }));
  const disabledData = locationDisabledData.map((item, index) => ({
    key: index,
    item: item,
    locationname: capitalizeFirstLetter(item.locationName1),
    name: capitalizeFirstLetter(item.locationName2),
    description: capitalizeFirstLetter(item.description),
    coordinates: {
      latitude: item?.googleMapPosition?.latitude,
      longitude: item?.googleMapPosition?.longitude,
    },
    googlemap: `https://www.google.com/maps?q=${item?.googleMapPosition?.latitude},${item?.googleMapPosition?.longitude}`,
    
  }));

  return (
    <div>
      <ToastContainer position="top-right" autoClose={2000} />

      <div className="flex justify-between mt-3 items-center">
        <p className="text-[17px] text-[#4B8AEB] font-sbold my-0 relative top-2">
          Active Locations
        </p>
        <button
          onClick={() => showForm(null)}
          className="h-[35px] border !border-[#00305F] !px-5 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all"
        >
          +Add New Location
        </button>
      </div>

      <div
        className="ag-theme-alpine text-base border-none font-proxima bordered"
        style={{ height: "auto", width: "100%", marginTop: "10px" }}
      >
        <AgGridReact
          gridOptions={gridOptions}
          columnDefs={columns}
          rowData={data}
          pagination={true}
          paginationPageSize={20}
          getRowHeight={() => 60}
          domLayout="autoHeight"
          paginationPageSizeSelector={false}
        />
      </div>
      <p className="text-[17px] text-[#4B8AEB] font-sbold mt-0 mb-3 relative top-2">
        Disabled Location
      </p>
      <div
        className="ag-theme-alpine text-base border-none font-proxima bordered"
        style={{ height: "auto", width: "100%", marginTop: "10px" }}
      >
        <AgGridReact
          gridOptions={gridOptions}
          columnDefs={disabledcolumns}
          rowData={disabledData}
          pagination={true}
          paginationPageSize={20}
          getRowHeight={() => 60}
          domLayout="autoHeight"
          paginationPageSizeSelector={false}
        />
      </div>
      <LocationForm
        open={formVisible}
        onCancel={hideForm}
        initialValues={editItem}
      />
      <ModalConfirm
        visible={modalDeleteLocVisible}
        onOk={() => handleOk(deleteLocData)}
        onCancel={handleCancel}
        title="Delete"
        content="Are you sure you want to delete?"
      />
      <ModalConfirm
        visible={modalDisableLocVisible}
        onOk={() => handleDisableOk(disableLocData)}
        onCancel={handleDisableCancel}
        title="Disable"
        content="Are you sure you want to disable?"
      />
      <ModalConfirm
        visible={modalActiveLocationVisible}
        onOk={() => handleActiveOk(activeLocationData)}
        onCancel={handleActiveCancel}
        title="Enable"
        content="Are you sure you want to enable?"
      />
    </div>
  );
}

export default Location;
